module.exports = __webpack_public_path__ + "media/images/icons/flags/BW-cbd9f5ac969ba6647841402c09647408.svg";